import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Shield } from "lucide-react";
import { OperationStatus } from "./OperationStatus";

export function OperationStatusCard({ bottlenecks }) {
  const bn = bottlenecks || {};
  return (
    <Card className="bg-white shadow-sm lg:col-span-2" data-testid="operation-status-card">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-gray-800">
          <Shield className="w-5 h-5 text-blue-500" />
          Status da Operação
        </CardTitle>
      </CardHeader>
      <CardContent>
        <OperationStatus status={bn.status || "healthy"} current={bn.current} />
        {(bn.bottlenecks || []).length > 0 && (
          <div className="mt-4 space-y-2">
            <p className="text-sm font-semibold text-gray-700">Alertas Detectados:</p>
            {bn.bottlenecks.map((b, i) => (
              <div
                key={i}
                className={`p-3 rounded-xl border ${b.severity === "critical" ? "bg-red-50 border-red-200" : "bg-amber-50 border-amber-200"}`}
              >
                <p className={`font-semibold text-sm ${b.severity === "critical" ? "text-red-700" : "text-amber-700"}`}>{b.title}</p>
                <p className="text-xs text-gray-600 mt-0.5">{b.detail}</p>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
